import React from 'react'
import { CompanyHeadings, CompanyLinksBackgroundImg, CompanyParagraphTexts, CompanyParagraphTextsLinks } from '../Blogs/CompanyLinksStyled';
import Container from 'components/layout/Container';
import Header from 'components/Header';

const PrivacyPolicy: React.FC = () => {

    return (
        <>
            <Header />

            <CompanyLinksBackgroundImg>
                <Container>

                    <CompanyHeadings>Privacy Policy for gamesfi.live</CompanyHeadings>
                    <CompanyParagraphTexts>
                        To use the Service, You must be a natural person, at least 18 years old, who is assigned to the Email address, Facebook or Google account associated with Your gamesfi.live : EARN REAL BITCOIN Account (the “gamesfi.live Account”). At our sole discretion, we may require proof that you meet this condition in connection with your use of the Service. Failure to comply with this condition will result in the closing of Your Account and the loss of all Virtual Items (gamesfi.live  Coins) (each as defined below) accumulated through your use of the Service.  The Service is not targeted at children under the age of 13, and they are not permitted to use the Service. We strongly encourage all parents and guardians to monitor the Internet use by their children. If you use the Service, you affirm you are at least 18 years old.
                    </CompanyParagraphTexts>

                    <CompanyHeadings>gamesfi.live</CompanyHeadings>
                    <CompanyParagraphTexts>
                        Earn Real Bitcoin will only use any personal information that you provide in connection with your use of the Service in accordance with the terms of our privacy policy available within the Application and on the Site here. By accessing or using the Service, You consent to the collection, use and storage of your information as outlined in the Privacy Policy. Questions regarding privacy issues should be directed to our customer service department at <a href='mailto:support@gamesfi.live'>support@gamesfi.live</a>
                    </CompanyParagraphTexts>

                    <CompanyHeadings>For more details visit our Link given below :</CompanyHeadings>
                    <CompanyParagraphTextsLinks>
                        <a href='https://gamefilive.blogspot.com/2022/01/privacy-policy-for-crypto-tiles.html' target='blank' rel="noreferrer">https://gamefilive.blogspot.com/2022/01/privacy-policy-for-crypto-tiles.html</a>
                    </CompanyParagraphTextsLinks>

                </Container>
            </CompanyLinksBackgroundImg>
        </>
    )
}

export default PrivacyPolicy;